import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';
import { SITE_URL } from '@/seo/siteConfig';

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Helmet>
        <title>Sayfa bulunamadı | Kombi Kurumsal Servis</title>
        <meta name="description" content="Aradığınız sayfa taşınmış veya silinmiş olabilir. Kombi servisi ana sayfasına dönebilir veya bizi arayabilirsiniz." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href={`${SITE_URL}/`} />
      </Helmet>
      <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-white">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-slate-100 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10 max-w-lg">
          <p className="text-sm font-semibold text-primary uppercase tracking-widest mb-2">Hata 404</p>
          <h2 className="text-xl md:text-2xl font-semibold text-slate-900 mt-2">Sayfa bulunamadı</h2>
          <p className="mt-3 text-sm text-slate-500 break-all">
            <span className="text-slate-400 font-mono text-xs">{location.pathname}</span>
          </p>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            Aradığınız adres yanlış yazılmış veya sayfa kaldırılmış olabilir. Ana sayfadan kombi servisi talebinde bulunabilirsiniz.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary-dark text-white font-bold text-sm px-6 py-3 rounded-full transition-colors"
            >
              Ana sayfaya dön
            </Link>
            <a
              href="tel:05332836679"
              className="inline-flex items-center justify-center gap-2 border border-slate-200 text-slate-800 font-semibold text-sm px-6 py-3 rounded-full hover:border-primary hover:text-primary transition-colors"
            >
              <i className="ri-phone-fill text-primary" />
              0533 283 66 79
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
